import type { LinkValue } from '@elfsight/configurator-contracts';
import { LinkBlock, type LinkBlockProps } from '@elfsight/widget-banner/widget';
import type { ClickAction } from '../../types';
import { usePopup } from '../../utils';

type LinkProps = LinkBlockProps & {
  clickAction: ClickAction;
};

export function Link({
  text,
  clickAction,
  link: derivedLink,
  ...forwardingProps
}: LinkProps) {
  const { close } = usePopup();

  let link: LinkValue | undefined;

  if (clickAction === 'redirect') {
    link = derivedLink;
  }

  const closeHandler = clickAction === 'closePopup' ? close : undefined;

  if (!text.trim()) {
    return;
  }

  return (
    <LinkBlock
      {...forwardingProps}
      text={text}
      link={link}
      customClickHandler={closeHandler}
    />
  );
}
